import { render, staticRenderFns } from "./BasePictureModal.vue?vue&type=template&id=22bb79fe&lang=pug"
import script from "./BasePictureModal.vue?vue&type=script&lang=js"
export * from "./BasePictureModal.vue?vue&type=script&lang=js"
import style0 from "./BasePictureModal.vue?vue&type=style&index=0&id=22bb79fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports